<template>
  <h6 class="element-header">
    Fallmanagement DRV
  </h6>

  <div>
    <h5 class="form-header">Berichtsportale:</h5>
    <div class="row mb-3">
      <div class="col-12">
        <h6 class="form-header">Fortschritt</h6>
        <div class="progress">
          <div class="progress-bar" role="progressbar" aria-valuemax="100" aria-valuemin="0" aria-valuenow="25"
               :style="{ width: styleWidth }">
            {{ formattedUnitsDonePercent }}%
          </div>
        </div>
      </div>
    </div>

    <div class="row m-0 portal_user_data p-3" style="font-size: 15px">
      <div class="col-lg-6 col-md-12">
        <div class="row">
          <div class="col-sm-5 col-6 mb-1"><strong>Vorname:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{ coaching?.unemployed?.firstName }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Nachname:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{ coaching?.unemployed?.lastName }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>JC / AA Nummer:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{ coaching?.unemployed?.aaNumber || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Versicherungsnr:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{
              coaching?.unemployed?.insuranceNumber || 'Keine Angaben'
            }}
          </div>

          <div class="col-sm-5 col-6 mb-1"><strong>Email:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic text-break">{{
              coaching?.unemployed?.email || 'Keine Angaben'
            }}
          </div>

          <div class="col-sm-5 col-6 mb-1"><strong>Telefonnummer:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{ coaching?.unemployed?.phone || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Sachbearbeiter:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{ coaching?.coaching?.clerk || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Adresse:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">
            {{ coaching?.unemployed?.address }},
            {{ coaching?.unemployed?.zip }} {{ coaching?.unemployed?.city }}
          </div>

          <div class="col-sm-5 col-6 mb-1"><strong>Kostenträger:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{ coaching?.client?.name || 'Keine Angaben' }}</div>
        </div>
      </div>

      <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
        <div class="d-flex flex-wrap justify-content-lg-end justify-content-center">

          <div class="portal-export-item m-0 text-center" style="min-width: 110px;">
            <a href="javascript:void(0)"
               class="btn portal_pdf_export w-100 d-flex flex-column align-items-center p-2"
               @click="downloadFile(`/portal/case-management-coaching/final-report-pdf/${coaching.id}`)">
              <img src="../../../../assets/img/pdf_icon_version4.png"
                   alt="PDF"
                   style="width: 55px; height: auto; object-fit: contain;"
                   class="mb-2"/>
              <p class="small mb-0 text-dark font-weight-bold" style="line-height: 1.1;">
                Abschlussbericht
              </p>
            </a>
          </div>

          <div
              v-if="coaching.digitalSignature"
              class="portal-export-item text-center"
              style="min-width: 110px;">
            <a href="javascript:void(0)"
               class="btn portal_pdf_export w-100 d-flex flex-column align-items-center p-2"
               @click="downloadFile(`/portal/case-management-coaching/confirmation-billing-report-pdf/${coaching.id}`,
               undefined
               )">
              <img src="../../../../assets/img/pdf_icon_version4.png"
                   alt="PDF"
                   style="width: 55px; height: auto; object-fit: contain;"
                   class="mb-2"/>
              <p class="small mb-0 text-dark font-weight-bold" style="line-height: 1.1;">
                Anwesenheitsliste
              </p>
            </a>
          </div>
        </div>
      </div>

      <div class="col-12 mt-4 border-top pt-3 d-flex flex-column flex-sm-row justify-content-between align-items-center">
        <div class="mb-2 mb-sm-0" v-if="coaching.digitalSignature">
          <button class="btn btn-outline-primary btn-md"
                  @click.prevent="handleRemoteDigitalSignatureModal()">
            <i class="os-icon os-icon-globe mr-1"></i> Digitale Unterschrift ONLINE
          </button>
        </div>

        <div class="text-center text-sm-right ml-sm-auto">
          <div class="h5 mb-0">
            <strong>{{ coaching?.calculatedUnits?.unitsDone }}</strong> / {{ coaching?.calculatedUnits?.maxUnits }}
            Einheiten
          </div>
          <div v-if="coaching?.calculatedUnits?.unitsLeft < 3" class="text-danger font-weight-bold middle mt-1">
            Sie haben noch {{ coaching.calculatedUnits.unitsLeft.toFixed(2) }} offene Einheiten
          </div>
        </div>
      </div>
    </div>
  </div>


  <Modal
      v-model="showRemoteDigitalSignatureModal"
      title="Digitale Unterschrift ONLINE"
      :hide-cancel="true"
      :button-label="$t('general.button.save')"
      sizeModal="modal-md"
      :hide-footer="true"
      classFooter="justify-content-center">
    <RemoteLInkForm
        :coachingId="coaching.id"
        :email="coaching?.unemployed?.email"
        :startDate="coaching?.startDate"
        :endDate="coaching?.endDate"
        @updateDigitalSignature="response"
        v-model:submitForm="formSubmit"/>
  </Modal>
</template>

<script setup>
import {downloadFile} from '@/shared/functions';
import {computed, defineProps, onMounted, ref, toRefs, watch} from 'vue';
import {CloseToast} from "@/components/VueToast";
import Modal from "@/components/modal/Modal.vue";
import RemoteLInkForm from "@/views/App/Portal/CaseManagementCoaching/RemoteDigitalSignature/RemoteLInkForm.vue";
const formSubmit = ref(false);

watch(formSubmit, () => {
  showRemoteDigitalSignatureModal.value = false;
});

const props = defineProps({
  coaching: {
    type: Object,
    required: true,
  },
});

const coaching = toRefs(props)['coaching'];
const unitsDonePercent = ref(0.0);
const showRemoteDigitalSignatureModal = ref(false);

const styleWidth = computed(() => {
  if (unitsDonePercent.value === 0.0) {
    return '0%';
  } else if (unitsDonePercent.value < 1) {
    return '3%';
  } else {
    return unitsDonePercent.value + '%';
  }
});

// Format the percentage value (2 decimal places)
const formattedUnitsDonePercent = computed(() => {
  return unitsDonePercent.value.toFixed(2).replace('.', ',');
});

watch(() => coaching.value.unitsDonePercent, (newVal) => {
  if (newVal !== null) {
    unitsDonePercent.value = +newVal;
  }
});

onMounted(() => { // Use onMounted to ensure props are available
  if (coaching.value && coaching.value.unitsDonePercent !== null) {
    unitsDonePercent.value = +coaching.value.unitsDonePercent;
  }
});


function handleRemoteDigitalSignatureModal() {
  CloseToast();
  showRemoteDigitalSignatureModal.value = true;
}

// async function downloadFileFinalReportPdf() {
//   try {
//     await client.get(`/portal/case-management-coaching/final-report-pdf/${coaching.value.id}`);
//     await downloadFile(`/portal/case-management-coaching/final-report-pdf/${coaching.value.id}`,
//         undefined);
//   } catch (error) {
//    await ErrorToast(error);
//   }
// }
//
// async function downloadFileConfirmationBillingReportPdf() {
//   try {
//     await client.get(`/portal/case-management-coaching/confirmation-billing-report-pdf/${coaching.value.id}`);
//     await downloadFile(`/portal/case-management-coaching/confirmation-billing-report-pdf/${coaching.value.id}`,
//         undefined);
//   } catch (error) {
//     await ErrorToast(error);
//   }
// }
</script>

<style scoped>

</style>